module.exports = __webpack_public_path__ + "static/media/management-icon.c175035f.svg";